import React from "react";
import { Input } from "antd";
import "./style.css";

const { Search } = Input;

const HexSearchBox = ({ value, onChange, onSubmit, className }) => {
  return (
    <div className={`hex-search-input ${className || ""}`}>
      <Search
        placeholder="Search..."
        onChange={(e) => onChange(e.target.value)}
        value={value}
        onPressEnter={(e) => onSubmit(e.target.value)}
      />
    </div>
  );
};

export default HexSearchBox;
